import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgBack = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 24 24"
    >
        <path
            d="M17 3.78788L15.1799 2L5 12L15.1799 22L17 20.2121L8.6401 12L17 3.78788Z"
            fill="current"
        />
    </svg>
);

export const BackIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon {...props} color={color} component={SvgBack} fontSize={fontSize} />
);
